/**
 * @function 获取bizId随机数
 */
 export function getBizId () {
  return 'mcs_' + (new Date()).getTime() + Math.random().toString(36).substr(2)
}

// 打开 Vue 的 devtools缩减版工具
export function openVueDevTools () {
  if (window.__vue_devtools__) {
    window.__vue_devtools__.run()
  } else {
    let url = 'https://erphostjs.kye-erp.com/module/public/vue-devtools/index.js'
    let _script = document.createElement('script')
    _script.src = url
    document.body.appendChild(_script)
  }
}



// WEBPACK FOOTER //
// ./src/shared/home-modules/helpers/utils.js